module.exports = __webpack_public_path__ + "images/smart_small6bee178f3b02c85eaa6762e0332e7369.png";